import React, { useState } from "react";
import { InboxItemType, InviteStatus, ParticipantSummary, PlaydateInvite, SeenStatus, User, useUpdateInboxSeenStatusMutation } from "../../../../../gql/types";
import PortalRoot from "../../../../portal/PortalRoot";
import { OverlayOpacity } from "../../../../portal/types";
import PlaydateInviteCanceledView from "../../../view/PlaydateInviteCanceledView";
import PlaydateInviteOrganizerCreationWorkflow from "../../PlaydateInviteOrganizerCreationWorkflow";
import InPlanningRecipientWorkflow from "./inplanning/InPlanningRecipientWorkflow";
import ConfirmedRecipientWorkflow from "./confirmed/ConfirmedRecipientWorkflow";

interface Props {
    user?: User;
    invite: PlaydateInvite;
    onBack: () => void;
    onDataChange: (success: boolean, invite?: PlaydateInvite) => void;
    baseZIndex?: number;
}

const PlaydateInviteRecipientReviewWorkflow: React.FC<Props> = ({ user, invite, onBack, onDataChange, baseZIndex }) => {
    const [showCreationWorkflow, setShowCreationWorkflow] = useState(false);

    let content;

    const [updateInboxSeenStatus] = useUpdateInboxSeenStatusMutation();

    React.useEffect(() => {
        if (!invite) return;

        const updateID = invite.guestUpdate?.updateID;
        if (!updateID || invite.guestUpdate?.seenState === SeenStatus.Read) return;

        updateInboxSeenStatus({
            variables: {
                itemType: InboxItemType.InboundPlaydate,
                input: updateID,
            },
        }).catch((err) => {
            console.warn("Failed to mark update as seen:", err);
        });
    }, [invite, updateInboxSeenStatus]);


    if (showCreationWorkflow) {
        return (
            // TODO: add onDataChange to the creation workflow
            <PlaydateInviteOrganizerCreationWorkflow
                onBack={() => setShowCreationWorkflow(false)}
                onDataChange={onDataChange}
                baseZIndex={baseZIndex}
                featureParameters={{
                }}
                initialConnections={[invite.organizer]}
            />
        );
    }

    if ((invite.status == InviteStatus.Abandoned || invite.status == InviteStatus.InPlanning) && invite.expired) {
        content = (
            <PlaydateInviteCanceledView
                invite={invite}
                onBack={onBack}
                baseZIndex={baseZIndex}
                onCreateNewInvite={() => setShowCreationWorkflow(true)}
            />
        );
    } else {
        switch (invite.status) {
            case InviteStatus.Abandoned:
                content = (
                    <PlaydateInviteCanceledView
                        invite={invite}
                        onBack={onBack}
                        baseZIndex={baseZIndex}
                        onCreateNewInvite={() => setShowCreationWorkflow(true)}
                    />
                );
                break;

            case InviteStatus.InPlanning:
                content = (
                    <InPlanningRecipientWorkflow
                        invite={invite}
                        onBack={onBack}
                        onDataChange={onDataChange}
                        user={user}
                    />
                )
                break;
            case InviteStatus.Confirmed:
                content = (
                    <ConfirmedRecipientWorkflow
                        invite={invite}
                        onBack={onBack}
                        baseZIndex={baseZIndex}
                        onDataChange={onDataChange}
                        onCreateNewInvite={() => setShowCreationWorkflow(true)}
                    />
                );
                break;

            default:
                content = (
                    <div style={{ padding: "2rem", textAlign: "center" }}>
                        <h3>View for status "{invite.status}" not yet implemented.</h3>
                    </div>
                );
        }
    }

    return (
        <PortalRoot overlayOpacity={OverlayOpacity.COVERED} baseZIndex={baseZIndex}>
            {content}
        </PortalRoot>
    );
};

export default PlaydateInviteRecipientReviewWorkflow;
